import {
	OPEN_MENU,
	CLOSE_MENU,
	CLOSE_ALL_MENUS,
	OPEN_FULLSCREEN_MOBILE_SUBNAV,
	CLOSE_FULLSCREEN_MOBILE_SUBNAV
} from '../actions/types';

const initialState = {
	openMenus: [],
	fullscreenMobileSubnavOpen: false,
	fullscreenMobileSubnavData: null
};

const menuReducer = (state = initialState, action) => {
	switch (action.type) {
		case OPEN_MENU:
			return {
				...state,
				openMenus: [...state.openMenus, action.menuItemId]
			};
		case CLOSE_MENU:
			return {
				...state,
				openMenus: state.openMenus.filter(
					(id) => id !== action.menuItemId
				)
			};

		case CLOSE_ALL_MENUS:
			return {
				...state,
				openMenus: []
			};
		case OPEN_FULLSCREEN_MOBILE_SUBNAV:
			return {
				...state,
				fullscreenMobileSubnavOpen: true,
				fullscreenMobileSubnavData: action.payload
			};
		case CLOSE_FULLSCREEN_MOBILE_SUBNAV:
			return {
				...state,
				fullscreenMobileSubnavOpen: false,
				fullscreenMobileSubnavData: null
			};
		default:
			return state;
	}
};

export default menuReducer;
